import { memo } from "react";

import { Button, Stack, useMediaQuery, useTheme } from "@mui/material";

interface IntervalButtonGroupProps {
  selected: boolean[];
  onClick: ((value: number | string) => void) | null;
  buttons: { name: string; value: number | string }[];
}

const IntervalButtonGroup: React.FC<IntervalButtonGroupProps> = ({ selected = [], onClick = null, buttons = [] }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const handleClick = (value: number | string) => {
    onClick?.(value);
  };

  return (
    <Stack direction="row" spacing={0.5} alignItems="center">
      {buttons.map(({ name, value }, index) => {
        const isSelected = selected[index];
        return (
          <Button
            key={`button-${index}`}
            onClick={() => handleClick(value)}
            size={isMobile ? "small" : "medium"}
            sx={{
              borderRadius: 50,
              textTransform: "capitalize",
              border: "none",
              backgroundColor: isSelected ? theme.palette.primary.main : "transparent",
              color: isSelected ? theme.palette.primary.contrastText : theme.palette.text.primary,
              boxShadow: isSelected ? `0 2px 3px 0 ${theme.palette.action.shadow}` : "none",
              "&:hover": {
                backgroundColor: isSelected ? theme.palette.primary.dark : undefined,
                boxShadow: isSelected ? `0 4px 6px 0 ${theme.palette.action.shadow}` : "none",
              },
            }}
          >
            {name}
          </Button>
        );
      })}
    </Stack>
  );
};

export default memo(IntervalButtonGroup);
